export default function EntidadeContextoHolder() {
  let value = undefined;

  function get() {
    return value ? value.context : undefined;
  }

  function getObject() {
    return value;
  }

  function put(key, obj) {
    value = obj.value;
  }

  function remove(key) {
    value = undefined;
  }

  function getRegion() {
    return '';
  }

  return {
    get: get,
    getObject: getObject,
    put: put,
    remove: remove,
    getRegion: getRegion
  };
}
